import { Component, Input, OnInit } from '@angular/core';
import { AttributeValue, EditedAttributeValues } from '../../../../../models/section-definition.model';

export interface AttributeValidationError {
  key: string;
  params?: Record<string, unknown>;
}

export function getNumberValidationError(
  attr: AttributeValue,
  value: number | null,
): AttributeValidationError | null {
  if (value == null) {
    return attr.isRequired ? { key: 'COMMON.ATTRIBUTE_VALIDATION.REQUIRED' } : null;
  }
  if (attr.regularExpression && !new RegExp(attr.regularExpression).test(String(value))) {
    return { key: 'COMMON.ATTRIBUTE_VALIDATION.INVALID_FORMAT' };
  }
  if (attr.maxNumberValue != null && value > attr.maxNumberValue) {
    return { key: 'COMMON.ATTRIBUTE_VALIDATION.MAX_VALUE', params: { max: attr.maxNumberValue } };
  }
  return null;
}

@Component({
  selector: 'lib-attribute-number-edit-row',
  standalone: false,
  templateUrl: './attribute-number-edit-row.component.html',
  styleUrls: ['./attribute-number-edit-row.component.scss'],
})
export class AttributeNumberEditRowComponent implements OnInit {
  @Input() attributeValue!: AttributeValue;
  @Input() editedValues: EditedAttributeValues = {};
  value: number | null = null;
  error: AttributeValidationError | null = null;

  ngOnInit(): void {
    const id = this.attributeValue.attributeDefinitionId;
    this.value = id in this.editedValues ? (this.editedValues[id] as number | null) : (this.attributeValue.doubleValue ?? null);
    this.validate(this.value);
  }

  onValueChange(value: number | null) {
    this.editedValues[this.attributeValue.attributeDefinitionId] = value;
    this.validate(value);
  }

  private validate(value: number | null) {
    this.error = value !== null && value === (this.attributeValue.doubleValue ?? null)
      ? null
      : getNumberValidationError(this.attributeValue, value);
  }
}
